import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import CountryRegionListItem from '@lmt-rpb/CountryRegionListItem/CountryRegionListItem.vue';
import { MOST_POPULAR_REGION_ID } from '@global-js/constants';
import { type RegionItem } from '@/interfaces/region-item';

interface Props {
	region: RegionItem;
	currency: string;
	hotelSummary: Record<string, number>;
	bestPrices: Record<string, number>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CountryItemListContent',
  props: {
    region: {},
    currency: {},
    hotelSummary: {},
    bestPrices: {}
  },
  setup(__props: any) {

const props = __props;

const summaryItem = computed(() => {
	return {
		Name: 'Alle Hotels',
		HotelCount: props.hotelSummary[props.region.code],
		Price: props.bestPrices[props.region.code],
		PriceLabel: 'Gesamtpreis ab',
		URL: props.region.RegionGroupURL
	};
});

const shouldShowSummaryItem = computed(() => props.region.Regions.length > 1 && props.region.RegionGroupID !== MOST_POPULAR_REGION_ID);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (shouldShowSummaryItem.value)
      ? (_openBlock(), _createBlock(CountryRegionListItem, {
          key: 0,
          class: "country-item-list__item",
          item: summaryItem.value,
          currency: _ctx.currency,
          "is-summary": ""
        }, null, 8 /* PROPS */, ["item", "currency"]))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.region.Regions, (item) => {
      return (_openBlock(), _createBlock(CountryRegionListItem, {
        key: item.RegionID,
        class: "country-item-list__item",
        item: item,
        currency: _ctx.currency
      }, null, 8 /* PROPS */, ["item", "currency"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})